import { api, getAuthHeader } from "../axiosConfig";

// Parses a spreadsheet server-side and returns sheets/headers/sample rows plus
// a suggested column mapping. Read-only — nothing is imported by a preview.
export async function previewImportService(file) {
  const formData = new FormData();
  formData.append("file", file);
  return await api
    .post("/data/preview", formData, {
      headers: getAuthHeader(),
      timeout: 60000,
    })
    .then((res) => res.data);
}

// Imports one sheet using an explicit column mapping ([{ index, target }]).
// Large sheets import row by row server-side, so this needs far more than the
// axios default 8s timeout.
export async function importMappedService(cid, file, sheet, mapping) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("sheet", sheet);
  formData.append("mapping", JSON.stringify(mapping));
  return await api
    .post(`/data/importMapped/${cid}`, formData, {
      headers: getAuthHeader(),
      timeout: 300000,
    })
    .then((res) => res.data);
}

// Downloads the full-CID CSV export. Returns the raw axios response so the
// caller can honor the server's Content-Disposition filename.
export async function exportCidService(cid) {
  return await api.get(`/data/export/${cid}`, {
    headers: getAuthHeader(),
    responseType: "blob",
    timeout: 300000,
  });
}
